import { createContext } from "react";

export type RequestExtraParamsContextState = Record<string, string>;

/**
 * Parâmetros extras enviados em todas as requisições feitas pelo `useApi`:
 * no body (requisições com corpo) ou na query string (GET/DELETE/HEAD).
 */
export const RequestExtraParamsContext =
  createContext<RequestExtraParamsContextState>({});
